<template>
  <div class="hello">
    <audia-header></audia-header>
  </div>
</template>

<script>
import http from '../http'
import AudiaHeader from './header'
export default {
  components:{
     AudiaHeader
  },
  name: 'HelloWorld',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  },
  created:()=>{
     

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue